@if (availability?.code === '01') {
    <ng-container
        *ngTemplateOutlet="
            availability?.tooltip?.length ? availabilityTextWithTooltip : availabilityTextWithoutTooltip
        "
    ></ng-container>
}

@if (availability?.code === '04' || availability?.code === '07') {
    <ecs-inventory-indicator
        (click)="$event.stopPropagation()"
        [status]="availability?.status"
        [oscTooltip]="customTooltipContent"
    ></ecs-inventory-indicator>
}

<ng-template #availabilityTextWithTooltip>
    <span [oscTooltip]="customTooltipContent">
        {{ availability?.text }}
    </span>
</ng-template>

<ng-template #availabilityTextWithoutTooltip>
    <span>{{ availability?.text }}</span>
</ng-template>

<ng-template #customTooltipContent>
    @if (availability?.tooltip?.length) {
        <osc-default-tooltip>
            <sew-ws-richtext>
                <p>{{ availability?.tooltip }}</p>
            </sew-ws-richtext>
        </osc-default-tooltip>
    }
</ng-template>
